import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AvantoRestaurantsService } from 'src/app/services/avanto-restaurants.service';
import { AvantoSessionService } from 'src/app/services/avanto-session.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-choose-food-page',
  templateUrl: './choose-food-page.component.html',
  styleUrls: ['./choose-food-page.component.scss']
})
export class ChooseFoodPageComponent implements OnInit, OnDestroy {
  sessionWatcher: Subscription = new Subscription();
  availabilityWatcher: Subscription = new Subscription();

  menuLoaded: boolean


  constructor(private route: ActivatedRoute, private restaurantsService: AvantoRestaurantsService, private avantoSession: AvantoSessionService) {
    //This code works like the ngInit.
    //The difference is that it's called even when I switch the route to this same page
    this.route.params.subscribe(val => {
      this.initialize();
    });
  }


  ngOnInit() { /* Don't write anything here. Use the initialize Method instead! */ }

  initialize() {
    this.menuLoaded = false;

    this.sessionWatcher = this.avantoSession.sessionSubject.subscribe((session) => {
      if (!this.menuLoaded) {
        this.menuLoaded = true;
        this.loadMenu(session.customerAddress.lat, session.customerAddress.lng);
      }
      //For some reason the unsubscribe method only works the second time I call this function,
      //that's why I need to use "menuLoaded"
      this.sessionWatcher.unsubscribe()
    });
  }

  /** Loads the menu for the restaurant whose name has been passed as a parameter on the URL
  * For example: www.website.com/RESTAURANT_NAME/choose-food ==> RESTAURANT_NAME will be searched
  * If the menu for the restaurant is already loaded on memory, it won't be loaded again
  * this.session.loadMenu(restaurantToLoad); 
  */
  loadMenu(custLatitude: number | null, custLongitude: number | null) {
    this.restaurantsService.loadMenu(this.route.snapshot.params['region'], this.route.snapshot.params['clientId'], custLatitude, custLongitude);
  }

  ngOnDestroy() {
    if (this.sessionWatcher != null && !this.sessionWatcher.closed) {
      this.sessionWatcher.unsubscribe();
    }
  }
}
